<template>
  <div class="main">
    <div class="col-gauche">
      <img src="../assets/overlayLogin.png" alt="image emotion culturel" />
    </div>
    <div class="col-droite">
      <form @submit="onSubmit" v-if="!send">
        <div class="information">
          <p>Champs obligatoires <span>*</span></p>
        </div>

        <div class="field">
          <label for="first_name">Prénom<span>*</span></label>
          <input
            type="text"
            v-model="form.firstName"
            name="first_name"
            id="first_name"
            placeholder="Prénom*"
            required
          />
        </div>

        <div class="field">
          <label for="last_name">Nom<span>*</span></label>
          <input
            type="text"
            v-model="form.lastName"
            name="last_name"
            id="last_name"
            placeholder="Nom*"
            required
          />
        </div>

        <div class="field">
          <label for="courriel">Courriel<span>*</span></label>
          <input
            type="email"
            v-model="form.email"
            name="courriel"
            id="courriel"
            placeholder="Courriel*"
            required
          />
        </div>

        <div class="field">
          <label for="courriel_confirm"
            >Confirmation adresse courriel<span>*</span></label
          >
          <input
            type="email"
            name="courriel_confirm"
            id="courriel_confirm"
            v-model="form.confirmEmail"
            placeholder="Confirmation adresse courriel*"
            required
          />
        </div>
        <span class="error-message" v-if="failCourriel === true">
          Courriel non identique
        </span>
        <div class="field">
          <div class="passwordCtn">
            <label for="password">Mot de passe</label>
            <input
              class="password"
              v-model="form.password"
              :type="passwordSecret"
              name="password"
              id="password"
              placeholder="Mot de passe*"
              autocomplete="current-password"
              required
            />
            <img
              v-if="passwordSecret == 'password'"
              src="../assets/invisible.png"
              class="togglePassword"
              id="password_toggle"
              @click="switchPasswordSecret('visible')"
            />
            <img
              v-if="passwordSecret == 'text'"
              src="../assets/visible.png"
              class="togglePassword"
              id="password_toggle"
              @click="switchPasswordSecret('invisible')"
            />
          </div>
        </div>

        <div class="field">
          <div class="passwordCtn">
            <label for="password_verif"
              >Confirmation de votre mot de passe</label
            >
            <input
              class="password"
              :type="passwordSecret"
              v-model="form.confirmPassword"
              name="password"
              id="password_verif"
              placeholder="Confirmation de votre mot de passe*"
              required
            />
            <img
              v-if="passwordSecret == 'password'"
              src="../assets/invisible.png"
              class="togglePassword"
              id="password_toggle"
              @click="switchPasswordSecret('visible')"
            />
            <img
              v-if="passwordSecret == 'text'"
              src="../assets/visible.png"
              class="togglePassword"
              id="password_toggle"
              @click="switchPasswordSecret('invisible')"
            />
          </div>
        </div>
        <span class="error-message" v-if="failPassword === true">
          Mot de passe non identique
        </span>
        <input class="btn-submit" type="submit" value="Créer un compte" />
        <p>
          Vous avez déjà un compte? <br />
          <a @click="toSignin" class="link">Connectez-vous </a>
          dès maintenant !
        </p>
      </form>
      <div class="information" v-else>
        <p>
          Afin de finaliser votre Espace client, vous devez vérifier vos
          courriels pour valider votre compte. Si vous ne voyez pas le courriel
          dans votre boîte de réception, vérifiez dans vos courriels
          indésirables.
        </p>

        <p>
          Si vous n’avez pas reçu ce courriel,
          <a class="link" @click="resentEmail({ email: form.email })"
            >cliquez ici</a
          >
          pour en recevoir un à nouveau.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      passwordSecret: "password",
      form: {},
      send: false,
      failCourriel: false,
      failPassword: false
    };
  },
  watch:{
    sendMail(){
      if(this.sendMail){
        this.send = true
      }

    }
  },
  methods: {
    switchPasswordSecret(state) {
      if (state == "visible") {
        this.passwordSecret = "text";
      }
      if (state == "invisible") {
        this.passwordSecret = "password";
      }
    },
    ...mapActions(["register", "resentEmail"]),
    toSignin() {
      this.$router.push({
        name: "Signin",
      });
    },
    onSubmit(event) {
      event.preventDefault();
      this.failPassword = false
      this.failCourriel = false
      if (
        this.form.confirmPassword === this.form.password &&
        this.form.confirmEmail === this.form.email
      ) {
        this.register({
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          email: this.form.email,
          password: this.form.password,
          redirectUri: this.form.redirectUri,
        });
        //this.send = true;
      }
      else{
        if(this.form.confirmPassword !== this.form.password){
          this.failPassword = true
        }
        else if(this.form.confirmEmail !== this.form.email){
          this.failCourriel = true
        }
      }
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      sendMail: (state) => state.auth.sendMail,
    }),
  },
  mounted() {
    this.form.redirectUri = this.$route.query.redirectUri;
  },
};
</script>

<style scoped src="../assets/styleLogin.css"></style>
